const formatPrescriberName = (prescriber) => {
  if (!prescriber || !prescriber['First Name']) {
    return '';
  }
  return [
    prescriber['Name Prefix'],
    prescriber['First Name'],
    prescriber['Last Name'],
    prescriber['Name Suffix'],
    prescriber.Credential,
  ].filter(Boolean).join(' ');
};

export default formatPrescriberName;



// WEBPACK FOOTER //
// ./src/utils/formatPrescriberName.js